import type { OverallResult, PermitStatus } from '../lib/types';

const RESULT_LABEL: Record<OverallResult, string> = {
  CLEAR: 'Clear',
  ADVISORY: 'Advisory',
  CRITICAL_STOP_WORK: 'Critical — Stop Work',
  SYSTEM_INDETERMINATE_BLOCK: 'System Indeterminate',
};

const RESULT_CLASS: Record<OverallResult, string> = {
  CLEAR: 'clear',
  ADVISORY: 'advisory',
  CRITICAL_STOP_WORK: 'critical',
  SYSTEM_INDETERMINATE_BLOCK: 'indeterminate',
};

export function ResultBadge({ result }: { result: OverallResult | null | undefined }) {
  if (!result) return <span className="status-badge neutral">Not evaluated</span>;
  return <span className={`status-badge ${RESULT_CLASS[result]}`}>{RESULT_LABEL[result]}</span>;
}

const PERMIT_STATUS_LABEL: Record<PermitStatus, string> = {
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted',
  UNDER_REVIEW: 'Under Review',
  APPROVED: 'Approved',
  ISSUED: 'Issued',
  ACTIVE_FIREWATCH: 'Active — Fire Watch',
  SUSPENDED: 'Suspended',
  EXTENDED: 'Extended',
  CLOSED: 'Closed',
  CANCELLED: 'Cancelled',
};

const PERMIT_STATUS_CLASS: Record<PermitStatus, string> = {
  DRAFT: 'neutral',
  SUBMITTED: 'advisory',
  UNDER_REVIEW: 'advisory',
  APPROVED: 'clear',
  ISSUED: 'clear',
  ACTIVE_FIREWATCH: 'advisory',
  SUSPENDED: 'critical',
  EXTENDED: 'advisory',
  CLOSED: 'neutral',
  CANCELLED: 'neutral',
};

export function PermitStatusBadge({ status }: { status: PermitStatus }) {
  return <span className={`status-badge ${PERMIT_STATUS_CLASS[status]}`}>{PERMIT_STATUS_LABEL[status]}</span>;
}
